import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiListItemButton from '@mui/material/ListItemButton';
import React from 'react';
import { FlexBox } from '../../box';
import { ColorIndicator } from '../../color-indicator';
import { Item } from '../../list/item';
import { styled } from '../../styled';
import { sentence, Typography } from '../../typography';
const isAutocompleteOption = (option) => Boolean(option &&
    Object.prototype.hasOwnProperty.call(option, 'label'));
const getDefaultOptionLabel = (option) => {
    if (isAutocompleteOption(option)) {
        return option.label;
    }
    if (typeof option === 'string' || typeof option === 'number') {
        return String(option);
    }
    throw new Error('[Autocomplete] Unsupported option type. Please provide `getOptionLabel` or use a AutocompleteOption | string | number as option');
};
const formatOptionLabel = (label, sentenceOptions) => (sentenceOptions ? sentence(label) : label);
const AutocompleteOptionItem = styled(MuiListItemButton)({
    width: '100%',
    alignItems: 'center'
});
const isSelected = (ariaSelected) => ariaSelected === true || ariaSelected === 'true';
const renderOptionItem = (liProps, content) => {
    const extendedLiProps = {
        ...liPropsExtension,
        ...liProps
    };
    return (_jsx(AutocompleteOptionItem, { component: "li", disableRipple: true, selected: isSelected(extendedLiProps['aria-selected']), ...extendedLiProps, children: content }));
};
// NOTE: workaround to visually fix the focused state
const liPropsExtension = {
    onMouseEnter: (e) => {
        e.currentTarget.classList.add('Mui-focused');
    },
    onMouseLeave: (e) => {
        e.currentTarget.classList.remove('Mui-focused');
    }
};
function renderOption(props) {
    if (process.env.NODE_ENV === 'development') {
        if (props.renderOption &&
            (props.getOptionColor || props.getOptionIcon)) {
            console.warn('[Autocomplete] `props.renderOption` will be overridden when providing `getOptionColor` or `getOptionIcon`');
        }
        if (props.getOptionColor && props.getOptionIcon) {
            throw new Error('[Autocomplete] Cannot provide both `getOptionColor` and `getOptionIcon`');
        }
    }
    if (props.getOptionColor) {
        const { getOptionColor } = props;
        return (liProps, option) => {
            const label = props.getOptionLabel?.(option) ?? getDefaultOptionLabel(option);
            return renderOptionItem(liProps, _jsxs(FlexBox, { gap: 2, stretch: true, vAlign: "center", children: [_jsx(ColorIndicator, { color: getOptionColor(option) }), _jsx(Typography, { children: formatOptionLabel(label, props.sentenceOptions) })] }));
        };
    }
    if (props.getOptionIcon) {
        return (liProps, option) => {
            const label = props.getOptionLabel?.(option) ?? getDefaultOptionLabel(option);
            const { icon, iconProps } = props.getOptionIcon(option);
            return renderOptionItem(liProps, _jsx(Item, { primary: formatOptionLabel(label, props.sentenceOptions), icon: icon, iconProps: iconProps }));
        };
    }
    return (liProps, option, ...args) => {
        const label = props.getOptionLabel?.(option) ?? getDefaultOptionLabel(option);
        return (props.renderOption?.({
            ...liPropsExtension,
            ...liProps
        }, option, ...args) ??
            renderOptionItem(liProps, _jsx(Item, { primary: formatOptionLabel(label, props.sentenceOptions) })));
    };
}
export default { renderOption };
